import MenuItem from '@mui/material/MenuItem';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import * as React from 'react';
import { useGroupsList } from '../../../sic-lib/api/hooks/useGroupsList';
import { DEFAULT_LIST_ID } from '../../../sic-lib/defaults';
import { ListItem, ListType } from '../../../sic-lib/types/Lists';
import { hasDistinctListId, hasMatchingListType } from '../../../sic-lib/utils/functionalFilters';

type Props = TextFieldProps & {
    onSelectHandler: React.Dispatch<{ listId: number }>;
    filter?: 'dynamic' | 'static';
    allowAllContacts?: boolean;
};

export default function SelectContactsList({
    onSelectHandler,
    filter,
    allowAllContacts = false,
    ...props
}: Props) {
    const { data: groupListsData } = useGroupsList();

    const lists = React.useMemo(() => {
        if (groupListsData) {
            return groupListsData;
        }

        return [];
    }, [groupListsData]);

    const [selectOptions, setSelectOptions] = React.useState<ListItem[]>([]);

    React.useEffect(() => {
        let filteredLists: ListItem[] = lists;

        if (filter && filter === 'dynamic') {
            filteredLists = filteredLists.filter(hasMatchingListType(ListType.dynamic));
        } else if (filter && filter === 'static') {
            filteredLists = filteredLists.filter(hasMatchingListType(ListType.static));
        }

        if (!allowAllContacts) {
            filteredLists = filteredLists.filter(hasDistinctListId(DEFAULT_LIST_ID));
        }

        setSelectOptions(filteredLists);
    }, [lists, filter, allowAllContacts]);

    const handleSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
        onSelectHandler({ listId: +event.target.value });
    };

    return (
        <TextField
            {...(props as TextFieldProps)}
            select
            id={props.id || 'select_contacts_list'}
            label={props.label || 'Select Contacts List'}
            onChange={handleSelect}
        >
            {selectOptions.map(lst => (
                <MenuItem key={lst.listId} value={lst.listId}>
                    {lst.name}
                </MenuItem>
            ))}
        </TextField>
    );
}
